import Box from '@mui/material/Box'

import LuneButton from '@/components/LuneButton'
import TwoColumnsWithSquareImage from '@/components/TwoColumnsWithSquareImage'

const WRAPPER_OFFSITE = 450
const WRAPPER_OFFSITE_MOBILE = 24

const SolutionsInformation = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 9,
                alignItems: 'center',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundImage: {
                    xs: 'url("/images/solutions-information/bg-mobile.png")',
                    md: 'url("/images/solutions-information/bg-desktop.png")',
                },
                pt: {
                    xs: 10,
                    md: 15,
                },
                pb: {
                    xs: 10,
                    md: 15,
                },
                pl: {
                    xs: `${WRAPPER_OFFSITE_MOBILE}px`,
                    md: `${WRAPPER_OFFSITE}px`,
                },
                pr: {
                    xs: `${WRAPPER_OFFSITE_MOBILE}px`,
                    md: `${WRAPPER_OFFSITE}px`,
                },
                ml: {
                    xs: `-${WRAPPER_OFFSITE_MOBILE}px !important`,
                    md: `-${WRAPPER_OFFSITE}px !important`,
                },
                width: {
                    xs: `calc(100% + ${2 * WRAPPER_OFFSITE_MOBILE}px)`,
                    md: `calc(100% + ${2 * WRAPPER_OFFSITE}px)`,
                },
            }}
        >
            <TwoColumnsWithSquareImage
                image={{
                    src: '/images/solutions-information/img-1.png',
                    alt: `Lune’s climate solutions are seamless, quick to integrate, and accurate`,
                }}
                title={`Lune’s climate solutions are seamless, quick to integrate, and accurate`}
                paragraph={
                    <>
                        {`Cultivate customer loyalty and position your business as a sustainability leader by embedding Lune’s precise emissions tracking, decision-useful emissions reporting, actionable carbon reduction recommendations, and high quality and transparent carbon offsetting into your value proposition. `}
                    </>
                }
                snippet={
                    <LuneButton label={'Explore our API docs'} href={'https://docs.lune.co/'} />
                }
                imageOnRight
            />
            <TwoColumnsWithSquareImage
                image={{
                    src: '/images/solutions-information/img-2.png',
                    alt: `Your customers want emissions intelligence – whether for regulatory purposes or to build a greener business`,
                }}
                title={`Your customers want emissions intelligence – whether for regulatory purposes or to build a greener business`}
                paragraph={
                    <>
                        {`From climate projects to carbon accounting, from scope 3 emissions calculations to carbon reductions, Lune allows you to embed climate action effortlessly into your platform, paving the way for a greener future. `}
                    </>
                }
                snippet={
                    <LuneButton
                        label={"Learn what's driving the green transition"}
                        href={'/resource-hub/eu-csrd'}
                    />
                }
            />
        </Box>
    )
}

export default SolutionsInformation
